// extracted by mini-css-extract-plugin
module.exports = {"Container":"Suggestion_Container__3XQe1","form":"Suggestion_form__1pyG5","Submit":"Suggestion_Submit__145eC","Error":"Suggestion_Error__1h-w_"};